import { render, staticRenderFns } from "./FilterDropdown.vue?vue&type=template&id=0b708d52&"
import script from "./FilterDropdown.vue?vue&type=script&lang=js&"
export * from "./FilterDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports